import React, { useEffect, useRef, useState } from "react";
import useDeviceType from "../../../../custom-hooks/DeviceType";
import WrapperCard from "../../../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";
import SearchSelectDropdown from "../../../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import {
  importGray,
  plusIcon,
  rightDirectionBlackIcon,
  searchIcon,
} from "../../../../assets";
import Button from "../../../../component-lib/Molecules/button/Button";
import Table from "../../../../component-lib/Organisms/table/EventEHRTable";
import EventEHRSwitchButton from "../../../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import MenuDropdown from "../../../../component-lib/Molecules/menuDropdown/MenuDropdown";
import { TEXT_CONSTANTS } from "../../../../utils/text-constants/textConstants";
import SelectDropdown from "../../../../component-lib/Atoms/Select/Select";
import AddRoleDailog from "../../dialogs/add-role-dailog/AddRoleDailog";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  componentKey,
  setCloseAddRolesResponsibilityDialog,
} from "../../SettingsSlice";
import {
  deleteRolesResponsibility,
  getRolesResponsibilityList,
  patchRolesResponsibilityData,
  postRolesResponsibilityData,
} from "../../SettingsSaga";
import EventEHRConfirmationDialog from "../../../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";

const RolesAndResponsibility = () => {
  const { rolesResponsibilityList, closeAddRolesResponsibilityDialog } =
    useSelector((state: any) => state[componentKey]);

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [rowPerPage, setRowPerPage] = useState("10");
  const [pageNumber, setPageNumber] = useState(1);
  const [searchedValue, setSearchValue] = useState<string>("");
  const [status, setStatus] = useState("");
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState<string | null>(null);
  const [defaultRoleDataRow, setDefaultRoleDataRow] = useState<any>({});

  // OPEN ADD/EDIT CODE DIALOG
  const [dialogState, setDialogState] = useState<null | "add" | "edit">(null);

  // OPEN ROLES AND RESPONSIBILITY  DIALOG
  const [openRolesResponsibilityDialog, setOpenRolesResponsibilityDialog] =
    useState(false);

  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ROLES AND RESPONSIBILITY COLUMN
  const rolesResponsibilityColumns = [
    {
      field: "roles",
      label: <div>Roles</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal  w-[5vw]">{row?.roles}</p>
        );
      },
    },
    {
      field: "description",
      label: <div>Description</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal w-[70vw]">
            {row?.description}
          </p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const apiPayload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  roleId: row?.id,
                };
                dispatch(patchRolesResponsibilityData(apiPayload));
              }}
            />{" "}
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "Edit Role",
                    onClickCb: () => {
                      setDefaultRoleDataRow(row);
                      setDialogState("edit"); // Open edit dialog
                      setOpenRolesResponsibilityDialog(true);
                    },
                  },
                  {
                    label: "Delete Role",
                    onClickCb: () => {
                      setSelectedRoleId(row?.id);
                      setOpenConfirmationDialog(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  //ROLES AND RESPONSIBILITY ROW DATA
  const rolesResponsibilityData = rolesResponsibilityList?.roles?.map(
    (data: any) => ({
      id: data?.id || "-",
      roles: data?.name || "-",
      description: data?.description || "-",
      status: data?.status || "-",
      allData: data || "-",
      type: data?.type || "",
    })
  );

  useEffect(() => {
    getRolesResponsibility();
  }, [searchedValue, rowPerPage, pageNumber, status]);

  useEffect(() => {
    if (closeAddRolesResponsibilityDialog) {
      dispatch(setCloseAddRolesResponsibilityDialog(false));
      setDialogState(null);
      setOpenRolesResponsibilityDialog(false);
      getRolesResponsibility();
      setOpenConfirmationDialog(false); // for delete code confirmation dialog(for api failing scenario)
    }
  }, [closeAddRolesResponsibilityDialog]);

  const getRolesResponsibility = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      searchValue: searchedValue?.trim(),
      status: status ? status : "",
    };
    dispatch(getRolesResponsibilityList(payload));
  };

  const addRolesResponsibility = (data: any, checkboxData: any) => {
    try {
      const payload = {
        name: data?.roleName,
        description: data?.description,
        type: data?.type,
        patient: {
          create: checkboxData?.[0]?.status,
          view: checkboxData?.[1]?.status,
          update: false,
          delete: false,
        },
        visit: {
          create: checkboxData?.[2]?.status,
          view: checkboxData?.[3]?.status,
          update: false,
          delete: false,
        },

        task: {
          create: checkboxData?.[4]?.status,
          view: checkboxData?.[5]?.status,
          update: checkboxData?.[6]?.status,
          delete: false,
        },
        contactDirectory: {
          create: checkboxData?.[7]?.status,
          view: false,
          update: checkboxData?.[8]?.status,
          delete: checkboxData?.[9]?.status,
        },
        // inventory: {
        //   // create: checkboxData?.[10]?.status,
        //   view: checkboxData?.[10]?.status,
        //   // update: checkboxData?.[12]?.status,
        //   // delete: checkboxData?.[13]?.status,
        // },
      };
      if (defaultRoleDataRow?.roles) {
        const rolesResponsibilityUpdatePayload = {
          payload: {
            ...payload,
            type: undefined,
            // name: undefined,
          },
          roleId: defaultRoleDataRow?.id,
        };
        dispatch(
          patchRolesResponsibilityData(rolesResponsibilityUpdatePayload)
        );
      } else {
        dispatch(postRolesResponsibilityData(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full gap-3">
        <div
          className={`flex ${deviceType === "mobile" || deviceType === "small-tablet" ? "flex-col items-start gap-3" : "items-center"} justify-between w-full`}
        >
          <div className="flex items-center gap-3">
            <img
              className="cursor-pointer"
              src={rightDirectionBlackIcon}
              alt="back-arrow"
              style={{ height: "12.5px" }}
              onClick={() => {
                navigate("/settings");
              }}
            />
            <Heading
              title={"Roles & Responsibilities"}
              customStyle={{ color: "#1D1D1D" }}
            />
          </div>

          <div
            className={`flex ${deviceType === "mobile" || deviceType === "small-tablet" ? "w-full justify-end" : ""} gap-3`}
          >
            <div style={{ maxWidth: "350px" }}>
              <SelectDropdown
                label=""
                name="status"
                placeholderValue="All Status"
                displayEmpty={true}
                value={status}
                options={[
                  { label: "Active", value: "Active" },
                  { label: "In Active", value: "InActive" },
                ]}
                onChangeCb={(e) => {
                  setStatus(e.target.value);
                  setPageNumber(1);
                }}
              />
            </div>
            <div>
              <SearchSelectDropdown
                freeSolo={true}
                searchedValue={searchedValue}
                onSearchValueChangeCb={(e) => handleChange(e)}
                size="small"
                label="Search by roles"
                fullWidth={deviceType === "mobile" ? "160px" : "300px"}
                startIcon={
                  <img
                    alt="search-icon"
                    src={searchIcon}
                    width={"18px"}
                    height={"18px"}
                  />
                }
              />
            </div>

            {/* <Button
              startIcon={
                <img
                  src={importGray}
                  alt={"search"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label="Import CSV"
              variant="outlined"
              onClickCb={() => {
                console.log("cliked");
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
                color: "#727272",
                border: "1px solid #D2D2D2",
                backgroundColor: "#FFFFFF",
                textTransform: "none",
                boxShadow: "none",
              }}
            ></Button> */}

            <Button
              startIcon={
                <img
                  src={plusIcon}
                  alt={"search"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label="Add Role"
              variant="contained"
              onClickCb={() => {
                setDefaultRoleDataRow({});
                setDialogState("add"); // Open add dialog
                setOpenRolesResponsibilityDialog(true);
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
              }}
            ></Button>
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <Table
            columns={rolesResponsibilityColumns}
            rows={rolesResponsibilityData}
            paginationProps={{
              isPagination: true,
              page: pageNumber,
              totalPages: rolesResponsibilityList?.totalPages,
              totalCount: rolesResponsibilityList?.total,
              limit: rowPerPage,
              rowsPerPageOptions: [10, 25, 50],
              onPageChange: (page: any) => {
                setPageNumber(page);
              },
              handleChangeRowsPerPage: (rowPerPage: any) => {
                setRowPerPage(rowPerPage);
                setPageNumber(1);
              },
            }}
          />
        </div>
      </div>
      {openRolesResponsibilityDialog && (
        <AddRoleDailog
          defaultRoleData={defaultRoleDataRow}
          isEdit={dialogState === "edit"} // Determine edit mode
          isOpen={!!dialogState} // Dialog is open if dialogState is not null          isOpen={openCodeDialog}
          handleClose={() => {
            setDialogState(null); // Close the dialog by setting to null
            setOpenRolesResponsibilityDialog(false);
          }}
          handleData={(data, checkboxData) => {
            addRolesResponsibility(data, checkboxData);
          }}
        />
      )}

      {openConfirmationDialog && (
        <EventEHRConfirmationDialog
          alertTitle={`Delete Role`}
          alertDescription={`Are you sure you want to delete this Role? Please confirm to proceed.`}
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openConfirmationDialog}
          handleClose={(action) => {
            if (action === "close") {
              setOpenConfirmationDialog(false);
            } else if (action === "submit") {
              if (selectedRoleId) {
                const payload = {
                  roleId: selectedRoleId,
                  comesFrom: "",
                };
                dispatch(deleteRolesResponsibility(payload));
              }
              // setOpenConfirmationDialog(false);
            }
          }}
        />
      )}
    </WrapperCard>
  );
};

export default RolesAndResponsibility;
